module.exports = __webpack_public_path__ + "static/media/hiw-icon-recieve-money.1be5e907.webp";